import type { LifeEvent } from '../../types/onelife.ts';

export const CENTENARIAN_EVENTS: LifeEvent[] = [
  {
    "id": "cen_01_anointing_of_sick",
    "stageKey": "centenarian",
    "age": 85,
    "titleVi": "Bí Tích Xức Dầu Bệnh Nhân & Của Ăn Đàng",
    "descriptionVi": "Khi tuổi cao sức yếu, Cha xứ đến tận giường bệnh ban Bí Tích Xức Dầu Bệnh Nhân và trao Mình Thánh Chúa làm Của Ăn Đàng.",
    "category": "faith",
    "requiredReligion": "catholic",
    "choices": [
      {
        "id": "cen_01_a",
        "textVi": "Sốt sắng lãnh nhận ơn thánh hóa và nâng đỡ của Bí Tích Xức Dầu Bệnh Nhân",
        "outcomeTextVi": "Ân sủng của Bí Tích Xức Dầu Bệnh Nhân xua tan mọi đau đớn thể xác, tâm hồn bạn ngập tràn sự bình an kỳ diệu.",
        "healthDelta": 15,
        "happinessDelta": 45,
        "wealthDelta": 0,
        "intellectDelta": 20,
        "relationsDelta": 35,
        "addSacrament": "Bí Tích Xức Dầu Bệnh Nhân",
        "addVirtue": "Lãnh nhận Bí Tích Xức Dầu Bệnh Nhân trong tâm tình phó thác trọn vẹn nơi lòng thương xót Chúa",
        "unlockAchievement": "Ơn Chết Lành Trong Bí Tích Xức Dầu Bệnh Nhân"
      },
      {
        "id": "cen_01_b",
        "textVi": "Cùng con cháu đọc kinh tạ ơn xung quanh giường bệnh",
        "outcomeTextVi": "Cả gia đình hiệp thông cầu nguyện sốt sắng, bầu khí thánh thiện bao trùm căn phòng.",
        "healthDelta": 10,
        "happinessDelta": 40,
        "wealthDelta": 0,
        "intellectDelta": 15,
        "relationsDelta": 45,
        "addSacrament": "Bí Tích Xức Dầu Bệnh Nhân"
      }
    ]
  },
  {
    "id": "cen_02_ninety_years_jubilee",
    "stageKey": "centenarian",
    "age": 90,
    "titleVi": "Cửu Thập Thượng Thọ — 90 Tuổi Phúc Lộc Thọ Khang",
    "descriptionVi": "Tròn 90 tuổi, Chủ tịch nước / Chính quyền địa phương gửi lụa đào và thiệp mừng thọ chúc mừng bậc đại thọ.",
    "category": "family",
    "choices": [
      {
        "id": "cen_02_a",
        "textVi": "Mặc áo gấm đỏ, tươi cười chụp ảnh lưu niệm cùng năm thế hệ con cháu tề tựu",
        "outcomeTextVi": "Ngũ đại đồng đường sum vầy — phúc đức hiếm có ngàn năm của một gia tộc.",
        "healthDelta": 15,
        "happinessDelta": 50,
        "wealthDelta": 10,
        "intellectDelta": 15,
        "relationsDelta": 50,
        "unlockAchievement": "Ngũ Đại Đồng Đường Bách Niên"
      },
      {
        "id": "cen_02_b",
        "textVi": "Nhắc lại lời cảm ơn trời đất, tổ tiên đã che chở suốt gần một thế kỷ",
        "outcomeTextVi": "Lời răn dạy của cụ sống mãi trong lòng các thế hệ cháu con.",
        "healthDelta": 10,
        "happinessDelta": 45,
        "wealthDelta": 0,
        "intellectDelta": 20,
        "relationsDelta": 45,
        "addVirtue": "Sống thọ đức độ, để lại phúc lộc dồi dào cho muôn đời con cháu"
      }
    ]
  },
  {
    "id": "cen_03_final_spiritual_testament",
    "stageKey": "centenarian",
    "age": 88,
    "titleVi": "Lời Trăn Trối Thiêng Liêng Dặn Dò Con Cháu",
    "descriptionVi": "Tập hợp đầy đủ con cháu bên giường, bạn nắm tay dặn dò những lời tâm huyết cuối cùng về đạo làm người và đức tin.",
    "category": "family",
    "choices": [
      {
        "id": "cen_03_a",
        "textVi": "Dặn dò: \"Các con hãy luôn yêu thương nhau, giữ vững đức tin và sống ngay thẳng lương thiện\"",
        "outcomeTextVi": "Tất cả con cháu đều quỳ gối gật đầu ghi lòng tạc dạ, tiếng nấc xúc động nghẹn ngào.",
        "healthDelta": 5,
        "happinessDelta": 45,
        "wealthDelta": 0,
        "intellectDelta": 25,
        "relationsDelta": 50,
        "addVirtue": "Để lại di chúc tinh thần và gia sản đức tin vô giá cho hậu thế"
      },
      {
        "id": "cen_03_b",
        "textVi": "Trao từng chuỗi hạt Mân Côi và kỷ vật cho các cháu chắt",
        "outcomeTextVi": "Mỗi kỷ vật là một mỏ neo đức tin giữ gìn sự gắn kết của cả dòng họ.",
        "healthDelta": 5,
        "happinessDelta": 40,
        "wealthDelta": -5,
        "intellectDelta": 20,
        "relationsDelta": 45
      }
    ]
  },
  {
    "id": "cen_04_centenarian_100",
    "stageKey": "centenarian",
    "age": 100,
    "titleVi": "Đại Thọ Bách Niên Giai Lão — 100 Tuổi",
    "descriptionVi": "Tròn một thế kỷ cuộc đời! 100 năm chứng kiến bao thăng trầm của lịch sử dân tộc và thế giới.",
    "category": "society",
    "choices": [
      {
        "id": "cen_04_a",
        "textVi": "Đón nhận bằng mừng thọ 100 tuổi của Nhà nước và lời chúc phúc của Tòa Giám Mục",
        "outcomeTextVi": "Cả tỉnh vinh danh cụ thọ bách niên, tấm gương sống trường thọ đạo đức hiếm có.",
        "healthDelta": 20,
        "happinessDelta": 50,
        "wealthDelta": 20,
        "intellectDelta": 30,
        "relationsDelta": 50,
        "unlockAchievement": "Kỷ Lục Đại Thọ 100 Tuổi"
      },
      {
        "id": "cen_04_b",
        "textVi": "Mỉm cười uống chén nước ấm, thanh thản nhìn ngắm con cháu quây quần",
        "outcomeTextVi": "Một kiếp người viên mãn tròn đầy như vầng trăng rằm.",
        "healthDelta": 15,
        "happinessDelta": 50,
        "wealthDelta": 0,
        "intellectDelta": 25,
        "relationsDelta": 50,
        "addVirtue": "Sống thọ trăm năm vẹn tròn ân nghĩa giữa đất trời"
      }
    ]
  },
  {
    "id": "cen_05_peaceful_departure_sleep",
    "stageKey": "centenarian",
    "age": 86,
    "titleVi": "Tạ Thế Bình An Trong Giấc Ngủ Ngàn Thu",
    "descriptionVi": "Giữa đêm thanh tĩnh, sau lời kinh tối nhẹ nhàng, bạn từ từ chìm vào giấc ngủ ngàn thu thanh thản, nhẹ gót về nguồn.",
    "category": "faith",
    "isFatalPossible": true,
    "choices": [
      {
        "id": "cen_05_a",
        "textVi": "Thở hơi thở cuối cùng trong thanh thản, gương mặt mỉm cười như đang ngủ",
        "outcomeTextVi": "Bạn tạ thế bình an trong tuổi già viên mãn, về cõi vĩnh hằng trong vòng tay nhân từ của Chúa.",
        "healthDelta": 0,
        "happinessDelta": 50,
        "wealthDelta": 0,
        "intellectDelta": 20,
        "relationsDelta": 50,
        "isFatal": true,
        "causeOfDeathVi": "Đại thọ viên mãn, an nghỉ thanh thản trong giấc ngủ ngàn thu",
        "addVirtue": "Ra đi bình an, thanh thản về nguồn sau kiếp nhân sinh vẹn tròn"
      },
      {
        "id": "cen_05_b",
        "textVi": "Nắm lấy tay con cháu thì thầm lời cảm ơn trước lúc trút hơi thở cuối cùng",
        "outcomeTextVi": "Sự ra đi thanh thản để lại niềm tiếc thương vô hạn nhưng ngập tràn bình an cho gia quyến.",
        "healthDelta": 0,
        "happinessDelta": 45,
        "wealthDelta": 0,
        "intellectDelta": 15,
        "relationsDelta": 50,
        "isFatal": true,
        "causeOfDeathVi": "Hưởng đại thọ viên mãn, tạ thế trong vòng tay con cháu"
      }
    ]
  },
  {
    "id": "cen_06_holy_requiem_mass",
    "stageKey": "centenarian",
    "age": 89,
    "titleVi": "Thánh Lễ An Táng Trang Nghiêm & Lời Tiễn Biệt",
    "descriptionVi": "Cộng đoàn giáo xứ và bà con lối xóm hiệp dâng Thánh Lễ An Táng cầu nguyện cho người quá cố.",
    "category": "faith",
    "requiredReligion": "catholic",
    "isFatalPossible": true,
    "choices": [
      {
        "id": "cen_06_a",
        "textVi": "Khép lại một đời chứng nhân đức tin, hiệp thông trong mầu nhiệm Các Thánh Thông Công",
        "outcomeTextVi": "Tiếng chuông sầu ngân nga trong niềm hy vọng Phục Sinh, linh hồn được đưa về đất thánh bình an.",
        "healthDelta": 0,
        "happinessDelta": 50,
        "wealthDelta": 0,
        "intellectDelta": 20,
        "relationsDelta": 50,
        "isFatal": true,
        "causeOfDeathVi": "Hoàn tất hành trình đức tin trần thế, an nghỉ trong niềm tin Phục Sinh",
        "addVirtue": "Một đời sống trọn vẹn đức tin, đức cậy và đức mến cho đến hơi thở cuối"
      }
    ]
  },
  {
    "id": "cen_07_sunlight_window",
    "stageKey": "centenarian",
    "age": 82,
    "titleVi": "Ánh Nắng Sớm Bên Cửa Sổ",
    "descriptionVi": "Ngồi trên chiếc ghế bập bênh gỗ, bạn sưởi nắng sớm và ngắm nhìn những chồi non mới nhú.",
    "category": "health",
    "choices": [
      {
        "id": "cen_07_a",
        "textVi": "Hít thở thật sâu không khí trong lành, tạ ơn thêm một ngày được sống",
        "outcomeTextVi": "Mỗi ngày mới trôi qua là một món quà vô giá của tạo hóa.",
        "healthDelta": 15,
        "happinessDelta": 35,
        "wealthDelta": 0,
        "intellectDelta": 15,
        "relationsDelta": 20
      },
      {
        "id": "cen_07_b",
        "textVi": "Uống từng ngụm nước ấm con cháu dâng tận tay",
        "outcomeTextVi": "Tình yêu thương chăm sóc chu đáo của con cháu làm ấm lòng cụ già.",
        "healthDelta": 15,
        "happinessDelta": 40,
        "wealthDelta": 0,
        "intellectDelta": 10,
        "relationsDelta": 35
      }
    ]
  },
  {
    "id": "cen_08_hearing_great_grand_laugh",
    "stageKey": "centenarian",
    "age": 84,
    "titleVi": "Tiếng Cười Đùa Của Lũ Chắt Ngoài Sân",
    "descriptionVi": "Lũ chắt rượt bắt nhau ngoài sân gạch râm mát, tiếng cười trong trẻo xua tan mọi mệt mỏi.",
    "category": "family",
    "choices": [
      {
        "id": "cen_08_a",
        "textVi": "Mỉm cười vẫy tay gọi chắt lại cho kẹo gừng ngọt ấm",
        "outcomeTextVi": "Chắt sà vào lòng cụ thơm lên má, niềm hạnh phúc giản dị mà thiêng liêng.",
        "healthDelta": 15,
        "happinessDelta": 45,
        "wealthDelta": -5,
        "intellectDelta": 10,
        "relationsDelta": 40
      },
      {
        "id": "cen_08_b",
        "textVi": "Nhìn đàn chắt lớn lên khoẻ mạnh và thấy tương lai dòng họ rạng rỡ",
        "outcomeTextVi": "Lòng cụ ngập tràn sự an tâm và mãn nguyện.",
        "healthDelta": 10,
        "happinessDelta": 40,
        "wealthDelta": 0,
        "intellectDelta": 15,
        "relationsDelta": 35
      }
    ]
  },
  {
    "id": "cen_09_old_songs",
    "stageKey": "centenarian",
    "age": 83,
    "titleVi": "Giai Điệu Thánh Ca / Dân Ca Quen Thuộc",
    "descriptionVi": "Con cháu bật lại những bài thánh ca quen thuộc hay làn điệu quan họ xưa cho bạn nghe.",
    "category": "faith",
    "choices": [
      {
        "id": "cen_09_a",
        "textVi": "Hát nhẩm theo từng lời ca thánh thót đong đầy kỷ niệm",
        "outcomeTextVi": "Âm nhạc đưa tâm hồn bạn bay bổng về những năm tháng thanh xuân tươi đẹp.",
        "healthDelta": 10,
        "happinessDelta": 40,
        "wealthDelta": 0,
        "intellectDelta": 15,
        "relationsDelta": 30
      },
      {
        "id": "cen_09_b",
        "textVi": "Rưng rưng xúc động nhớ về người bạn đời nơi chín suối",
        "outcomeTextVi": "Tình yêu bất tử vượt qua ranh giới thời gian và không gian.",
        "healthDelta": 5,
        "happinessDelta": 35,
        "wealthDelta": 0,
        "intellectDelta": 15,
        "relationsDelta": 25
      }
    ]
  },
  {
    "id": "cen_10_gentle_touch",
    "stageKey": "centenarian",
    "age": 87,
    "titleVi": "Bàn Tay Gầy Gò Được Nắm Chặt",
    "descriptionVi": "Đứa con cả nay cũng đã tóc hoa râm ngồi cạnh bên bóp chân và nắm chặt bàn tay nhăn nheo của bạn.",
    "category": "family",
    "choices": [
      {
        "id": "cen_10_a",
        "textVi": "Xoa đầu con và nói: \"Con đã vất vả nhiều rồi, cha/mẹ tự hào về con\"",
        "outcomeTextVi": "Người con bật khóc nức nở như đứa trẻ được mẹ dỗ dành, tình mẫu tử/phụ tử thiêng liêng.",
        "healthDelta": 10,
        "happinessDelta": 45,
        "wealthDelta": 0,
        "intellectDelta": 15,
        "relationsDelta": 50,
        "addVirtue": "Tình cha mẹ bao la như biển thái bình cho đến tận cuối đời"
      },
      {
        "id": "cen_10_b",
        "textVi": "Mỉm cười gật đầu trao gửi trọn vẹn niềm tin cậy",
        "outcomeTextVi": "Sự bình yên thầm lặng giữa hai thế hệ sâu sắc hơn ngàn vạn lời nói.",
        "healthDelta": 10,
        "happinessDelta": 40,
        "wealthDelta": 0,
        "intellectDelta": 10,
        "relationsDelta": 45
      }
    ]
  },
  {
    "id": "cen_11_silent_prayer_peace",
    "stageKey": "centenarian",
    "age": 86,
    "titleVi": "Giờ Kinh Thầm Lặng Trong Đêm",
    "descriptionVi": "Dù sức khỏe yếu, trong tâm trí bạn vẫn không ngừng thầm thì lời kinh Kính Mừng và kinh Lạy Cha.",
    "category": "faith",
    "requiredReligion": "catholic",
    "choices": [
      {
        "id": "cen_11_a",
        "textVi": "Thầm thì lời kinh phó thác trọn vẹn linh hồn cho Chúa",
        "outcomeTextVi": "Ơn bình an thiêng liêng tỏa sáng quanh giường bệnh, nâng đỡ cả gia đình.",
        "healthDelta": 10,
        "happinessDelta": 45,
        "wealthDelta": 0,
        "intellectDelta": 20,
        "relationsDelta": 30,
        "addVirtue": "Cầu nguyện không ngừng nghỉ cho đến hơi thở cuối cùng"
      },
      {
        "id": "cen_11_b",
        "textVi": "Cầu xin cho quê hương đất nước luôn được thái bình, thịnh vượng",
        "outcomeTextVi": "Tấm lòng yêu nước thơm thảo của bậc tiền nhân sống mãi cùng núi sông.",
        "healthDelta": 5,
        "happinessDelta": 40,
        "wealthDelta": 0,
        "intellectDelta": 20,
        "relationsDelta": 35
      }
    ]
  },
  {
    "id": "cen_12_century_of_memories",
    "stageKey": "centenarian",
    "age": 92,
    "titleVi": "Hồi Tưởng Một Thế Kỷ Thăng Trầm",
    "descriptionVi": "Nhìn lại cuộc đời từ thời thơ ấu chăn trâu cắt cỏ cho đến thời đại vệ tinh viễn thông hôm nay.",
    "category": "education",
    "choices": [
      {
        "id": "cen_12_a",
        "textVi": "Cảm thán sự đổi thay kỳ diệu của nhân loại và lòng biết ơn sâu sắc",
        "outcomeTextVi": "Tâm trí cụ như pho sử sống quý báu của cả làng quê.",
        "healthDelta": 10,
        "happinessDelta": 45,
        "wealthDelta": 0,
        "intellectDelta": 30,
        "relationsDelta": 35
      },
      {
        "id": "cen_12_b",
        "textVi": "Kể cho cháu ghi âm lại những câu chuyện thời kháng chiến gian khổ",
        "outcomeTextVi": "Tài liệu quý báu được lưu giữ làm ký ức lịch sử địa phương.",
        "healthDelta": 5,
        "happinessDelta": 40,
        "wealthDelta": 0,
        "intellectDelta": 30,
        "relationsDelta": 40
      }
    ]
  },
  {
    "id": "cen_13_taste_of_sweet_soup",
    "stageKey": "centenarian",
    "age": 85,
    "titleVi": "Muỗng Chè Hạt Sen Long Nhãn Thanh Ngọt",
    "descriptionVi": "Đứa cháu dâu cẩn thận nấu bát chè hạt sen nhãn lồng thơm mát đút cho bạn từng muỗng nhỏ.",
    "category": "health",
    "choices": [
      {
        "id": "cen_13_a",
        "textVi": "Nuốt từng muỗng chè ngọt mát, mỉm cười khen cháu dâu khéo léo",
        "outcomeTextVi": "Vị ngọt thanh đượm tình hiếu thảo làm rạng rỡ gương mặt già nua.",
        "healthDelta": 15,
        "happinessDelta": 40,
        "wealthDelta": 0,
        "intellectDelta": 10,
        "relationsDelta": 40
      },
      {
        "id": "cen_13_b",
        "textVi": "Dặn con cháu chia nhau cùng ăn cho mát ruột",
        "outcomeTextVi": "Tấm lòng luôn nghĩ đến người khác dù bản thân đang đau yếu.",
        "healthDelta": 10,
        "happinessDelta": 40,
        "wealthDelta": 0,
        "intellectDelta": 10,
        "relationsDelta": 45,
        "addVirtue": "Luôn nghĩ đến người khác và sẻ chia đến phút cuối đời"
      }
    ]
  },
  {
    "id": "cen_14_autumn_leaves",
    "stageKey": "centenarian",
    "age": 91,
    "titleVi": "Lá Rụng Về Cội — Mùa Thu Cuối Cùng",
    "descriptionVi": "Những chiếc lá vàng chao nghiêng ngoài sân, bạn cảm nhận vòng tuần hoàn tự nhiên của trời đất.",
    "category": "society",
    "choices": [
      {
        "id": "cen_14_a",
        "textVi": "Bình thản mỉm cười đón nhận mùa thu, lòng thanh thản như nước đầu nguồn",
        "outcomeTextVi": "Tâm cảnh cao thượng giải thoát khỏi mọi ràng buộc trần thế.",
        "healthDelta": 10,
        "happinessDelta": 45,
        "wealthDelta": 0,
        "intellectDelta": 25,
        "relationsDelta": 25
      },
      {
        "id": "cen_14_b",
        "textVi": "Cùng cháu ngắm cây mai đang ủ nụ chờ xuân sang",
        "outcomeTextVi": "Niềm tin vào sức sống mới bất diệt của thế hệ cháu con.",
        "healthDelta": 10,
        "happinessDelta": 40,
        "wealthDelta": 0,
        "intellectDelta": 20,
        "relationsDelta": 35
      }
    ]
  },
  {
    "id": "cen_15_sacramental_blessing_home",
    "stageKey": "centenarian",
    "age": 88,
    "titleVi": "Linh Mục Đến Tư Gia Ban Phép Lành Tòa Thánh",
    "descriptionVi": "Cha xứ trao Phép Lành Tòa Thánh từ Đức Giáo Hoàng nhân dịp mừng đại thọ tại gia đình.",
    "category": "faith",
    "requiredReligion": "catholic",
    "choices": [
      {
        "id": "cen_15_a",
        "textVi": "Cúi đầu sốt sắng đón nhận Phép Lành Tòa Thánh với lòng tri ân sâu xa",
        "outcomeTextVi": "Ơn lành bao phủ mái nhà, con cháu hân hoan rạng rỡ đón nhận phúc lộc.",
        "healthDelta": 15,
        "happinessDelta": 50,
        "wealthDelta": 0,
        "intellectDelta": 20,
        "relationsDelta": 45,
        "addVirtue": "Đón nhận Phép Lành Tòa Thánh trong niềm hân hoan thánh thiện"
      },
      {
        "id": "cen_15_b",
        "textVi": "Mời Cha xứ và ban hành giáo dùng chén trà thanh đạm",
        "outcomeTextVi": "Sự gắn kết bền chặt giữa gia đình và Giáo hội Công giáo suốt cả một đời.",
        "healthDelta": 10,
        "happinessDelta": 40,
        "wealthDelta": -5,
        "intellectDelta": 15,
        "relationsDelta": 40
      }
    ]
  },
  {
    "id": "cen_16_peaceful_passing_100",
    "stageKey": "centenarian",
    "age": 101,
    "titleVi": "Trăm Năm Một Kiếp Nhân Sinh — Đại Thọ Tạ Thế",
    "descriptionVi": "Sau hơn một thế kỷ sống trọn vẹn yêu thương, cụ già thọ 101 tuổi thanh thản khép lại cuộc hành trình trần thế kỳ diệu.",
    "category": "faith",
    "isFatalPossible": true,
    "choices": [
      {
        "id": "cen_16_a",
        "textVi": "Thanh thản mỉm cười trút hơi thở cuối cùng trong tiếng kinh cầu nguyện của năm thế hệ",
        "outcomeTextVi": "Một kiếp người đại thọ viên mãn, để lại phúc lộc và gương sáng rực rỡ muôn đời.",
        "healthDelta": 0,
        "happinessDelta": 50,
        "wealthDelta": 0,
        "intellectDelta": 30,
        "relationsDelta": 50,
        "isFatal": true,
        "causeOfDeathVi": "Đại thọ bách niên viên mãn, tạ thế bình an trong tuổi 101",
        "addVirtue": "Trăm năm sống trọn vẹn chữ Tâm, chữ Đức và tấm lòng nhân hậu",
        "unlockAchievement": "Bách Niên Đại Thọ Hoàn Hảo"
      }
    ]
  },
  {
    "id": "cen_17_blessing_all_descendants",
    "stageKey": "centenarian",
    "age": 86,
    "titleVi": "Đặt Tay Chúc Lành Cho Từng Đứa Cháu Chắt",
    "descriptionVi": "Cụ đặt bàn tay run rẩy lên đầu từng đứa cháu chắt, chúc cho các cháu học hành chăm chỉ, ngoan ngoãn.",
    "category": "family",
    "choices": [
      {
        "id": "cen_17_a",
        "textVi": "Cất tiếng chúc: \"Chúa chúc lành cho các con các cháu của cụ\"",
        "outcomeTextVi": "Lời chúc phúc chân thành như dòng suối mát lành tưới đẫm tâm hồn con trẻ.",
        "healthDelta": 10,
        "happinessDelta": 45,
        "wealthDelta": 0,
        "intellectDelta": 15,
        "relationsDelta": 50,
        "addVirtue": "Chúc lành yêu thương cho đàn con cháu trước lúc đi xa"
      },
      {
        "id": "cen_17_b",
        "textVi": "Xoa đầu từng đứa chắt với nụ cười hiền như ông bụt trong truyện cổ tích",
        "outcomeTextVi": "Hình ảnh đẹp đẽ của cụ in sâu vào tâm trí con trẻ suốt cuộc đời.",
        "healthDelta": 10,
        "happinessDelta": 45,
        "wealthDelta": 0,
        "intellectDelta": 10,
        "relationsDelta": 45
      }
    ]
  },
  {
    "id": "cen_18_old_photographs_wall",
    "stageKey": "centenarian",
    "age": 87,
    "titleVi": "Bức Tường Ảnh Gia Tộc Ngắm Nhìn",
    "descriptionVi": "Ngồi trên xe lăn, bạn được đẩy đi ngắm nhìn bức tường treo đầy ảnh kỷ niệm của gia đình qua nhiều thế hệ.",
    "category": "family",
    "choices": [
      {
        "id": "cen_18_a",
        "textVi": "Chỉ tay vào từng bức ảnh nhắc tên từng người thân yêu",
        "outcomeTextVi": "Trí nhớ mẫn tiệp kỳ diệu của cụ khiến con cháu vô cùng thán phục.",
        "healthDelta": 10,
        "happinessDelta": 40,
        "wealthDelta": 0,
        "intellectDelta": 25,
        "relationsDelta": 40
      },
      {
        "id": "cen_18_b",
        "textVi": "Mỉm cười tạ ơn vì hạt giống gia đình đã đâm chồi nảy lộc thành cây đại thụ",
        "outcomeTextVi": "Cảm giác mãn nguyện ngập tràn lồng ngực.",
        "healthDelta": 15,
        "happinessDelta": 45,
        "wealthDelta": 0,
        "intellectDelta": 20,
        "relationsDelta": 45
      }
    ]
  },
  {
    "id": "cen_19_birdsong_morning",
    "stageKey": "centenarian",
    "age": 89,
    "titleVi": "Tiếng Chim Hót Chào Ngày Mới",
    "descriptionVi": "Bình minh hé rạng, tiếng chim chào mào hót vang trên cành bưởi trước hiên.",
    "category": "health",
    "choices": [
      {
        "id": "cen_19_a",
        "textVi": "Lắng nghe tiếng hót trong niềm hân hoan thanh khiết",
        "outcomeTextVi": "Tâm hồn trong trẻo như trẻ thơ, không một gợn bụi trần.",
        "healthDelta": 15,
        "happinessDelta": 40,
        "wealthDelta": 0,
        "intellectDelta": 15,
        "relationsDelta": 20
      },
      {
        "id": "cen_19_b",
        "textVi": "Ngửi hương hoa bưởi thoang thoảng bay vào phòng",
        "outcomeTextVi": "Hương thơm quê nhà nâng niu từng giác quan của cụ già.",
        "healthDelta": 15,
        "happinessDelta": 40,
        "wealthDelta": 0,
        "intellectDelta": 10,
        "relationsDelta": 25
      }
    ]
  },
  {
    "id": "cen_20_warm_tea_drop",
    "stageKey": "centenarian",
    "age": 93,
    "titleVi": "Ngụm Nước Trà Ấm Đượm Tình Thân",
    "descriptionVi": "Được người con gái út thổi nguội từng ngụm nước trà sen đưa vào khóe môi.",
    "category": "health",
    "choices": [
      {
        "id": "cen_20_a",
        "textVi": "Uống ngụm trà ấm và gật đầu cảm ơn con gái",
        "outcomeTextVi": "Hơi ấm tình thân lan tỏa khắp châu thân làm dịu mát cõi lòng.",
        "healthDelta": 15,
        "happinessDelta": 40,
        "wealthDelta": 0,
        "intellectDelta": 10,
        "relationsDelta": 45
      },
      {
        "id": "cen_20_b",
        "textVi": "Nắm lấy bàn tay chai sần của con gái với lòng thương vô hạn",
        "outcomeTextVi": "Tình mẫu tử/phụ tử trường tồn bất biến qua bao tháng năm.",
        "healthDelta": 10,
        "happinessDelta": 45,
        "wealthDelta": 0,
        "intellectDelta": 15,
        "relationsDelta": 50
      }
    ]
  },
  {
    "id": "cen_21_peaceful_candle",
    "stageKey": "centenarian",
    "age": 87,
    "titleVi": "Ngọn Nến Phục Sinh Lung Linh",
    "descriptionVi": "Cây nến thánh thắp sáng bên ảnh Chúa Giêsu nhân lành ban ơn bình an.",
    "category": "faith",
    "requiredReligion": "catholic",
    "choices": [
      {
        "id": "cen_21_a",
        "textVi": "Nhìn ánh nến và hướng lòng về quê hương vĩnh hằng trên trời",
        "outcomeTextVi": "Lòng cậy trông vững vàng xua tan bóng tối sợ hãi cái chết.",
        "healthDelta": 10,
        "happinessDelta": 45,
        "wealthDelta": 0,
        "intellectDelta": 20,
        "relationsDelta": 30,
        "addVirtue": "Đức trông cậy kiên vững vào cõi phúc đời đời"
      },
      {
        "id": "cen_21_b",
        "textVi": "Làm dấu Thánh Giá thánh thiện trên trán",
        "outcomeTextVi": "Dấu ấn đức tin theo bạn từ thuở lọt lòng đến phút lâm chung.",
        "healthDelta": 10,
        "happinessDelta": 40,
        "wealthDelta": 0,
        "intellectDelta": 15,
        "relationsDelta": 35
      }
    ]
  },
  {
    "id": "cen_22_forgiveness_all",
    "stageKey": "centenarian",
    "age": 89,
    "titleVi": "Tha Thứ Cho Tất Cả Mọi Người",
    "descriptionVi": "Trong những ngày tháng cuối cùng, bạn không giữ lại bất cứ điều gì oán trách trong lòng.",
    "category": "society",
    "choices": [
      {
        "id": "cen_22_a",
        "textVi": "Mở rộng lòng tha thứ cho tất cả và cầu chúc bình an cho mọi người",
        "outcomeTextVi": "Tâm hồn trong sáng tinh tuyền như pha lê, sẵn sàng về chốn bình yên.",
        "healthDelta": 15,
        "happinessDelta": 50,
        "wealthDelta": 0,
        "intellectDelta": 25,
        "relationsDelta": 45,
        "addVirtue": "Khoan dung tha thứ tất cả mọi oán thù, đạt tới sự bình an tuyệt đối"
      },
      {
        "id": "cen_22_b",
        "textVi": "Cảm tạ mọi nghịch cảnh đã từng giúp mình rèn giũa lòng kiên nhẫn",
        "outcomeTextVi": "Trí tuệ viên mãn nhìn nhận mọi sự xảy ra đều là ân huệ nhiệm mầu.",
        "healthDelta": 10,
        "happinessDelta": 45,
        "wealthDelta": 0,
        "intellectDelta": 30,
        "relationsDelta": 35
      }
    ]
  },
  {
    "id": "cen_23_smiling_to_eternity",
    "stageKey": "centenarian",
    "age": 94,
    "titleVi": "Nụ Cười Thanh Thản Trước Cõi Vĩnh Hằng",
    "descriptionVi": "Bạn nhìn quanh thấy con cháu ngoan ngoãn, xóm làng ấm no, lòng ngập tràn niềm vui tạ ơn.",
    "category": "faith",
    "choices": [
      {
        "id": "cen_23_a",
        "textVi": "Nở nụ cười hiền từ trút bỏ mọi âu lo",
        "outcomeTextVi": "Nụ cười tỏa rạng bình an thánh thiện làm dịu lòng tất cả những người xung quanh.",
        "healthDelta": 15,
        "happinessDelta": 50,
        "wealthDelta": 0,
        "intellectDelta": 20,
        "relationsDelta": 45
      },
      {
        "id": "cen_23_b",
        "textVi": "Thì thầm lời tạ ơn cuộc đời đã cho mình một kiếp sống thật đẹp",
        "outcomeTextVi": "Một kiếp nhân sinh đáng sống, đầy ắp hoa thơm quả ngọt của tình thương.",
        "healthDelta": 10,
        "happinessDelta": 50,
        "wealthDelta": 0,
        "intellectDelta": 25,
        "relationsDelta": 45,
        "addVirtue": "Sống trọn một đời tạ ơn và yêu thương không hề nuối tiếc"
      }
    ]
  },
  {
    "id": "cen_24_family_gratitude",
    "stageKey": "centenarian",
    "age": 95,
    "titleVi": "Lời Cảm Ơn Đàn Con Cháu Hiếu Thảo",
    "descriptionVi": "Con cháu túc trực ngày đêm phụng dưỡng chu đáo, không một lời than thở.",
    "category": "family",
    "choices": [
      {
        "id": "cen_24_a",
        "textVi": "Nói lời cảm ơn đàn con cháu hiếu thảo đã yêu thương chăm sóc cụ",
        "outcomeTextVi": "Con cháu xúc động nghẹn ngào, cảm nhận phúc đức tổ tiên sâu dày.",
        "healthDelta": 10,
        "happinessDelta": 50,
        "wealthDelta": 0,
        "intellectDelta": 15,
        "relationsDelta": 50
      },
      {
        "id": "cen_24_b",
        "textVi": "Cầu xin ơn trên gìn giữ các con cháu luôn yêu thương nhau như ngày hôm nay",
        "outcomeTextVi": "Sự đoàn kết gia đình được củng cố bền vững qua muôn thế hệ.",
        "healthDelta": 10,
        "happinessDelta": 45,
        "wealthDelta": 0,
        "intellectDelta": 20,
        "relationsDelta": 50
      }
    ]
  },
  {
    "id": "cen_25_last_breath_blessing",
    "stageKey": "centenarian",
    "age": 96,
    "titleVi": "Hơi Thở Cuối Cùng Bình Yên Bên Gia Đình",
    "descriptionVi": "Được bao bọc trong vòng tay của những người thân yêu nhất, bạn trút hơi thở cuối cùng nhẹ nhàng.",
    "category": "faith",
    "isFatalPossible": true,
    "choices": [
      {
        "id": "cen_25_a",
        "textVi": "Nhắm mắt xuôi tay an nghỉ trong tiếng cầu nguyện yêu thương của gia đình",
        "outcomeTextVi": "Bạn an nghỉ thanh thản ở tuổi 96 đại thọ, để lại di sản tình yêu bất diệt.",
        "healthDelta": 0,
        "happinessDelta": 50,
        "wealthDelta": 0,
        "intellectDelta": 20,
        "relationsDelta": 50,
        "isFatal": true,
        "causeOfDeathVi": "Đại thọ viên mãn 96 tuổi, tạ thế bình an trong vòng tay gia đình"
      }
    ]
  },
  {
    "id": "cen_26_eternal_peace",
    "stageKey": "centenarian",
    "age": 98,
    "titleVi": "Trở Về Nơi Bình Yên Vĩnh Cửu",
    "descriptionVi": "Hành trình một kiếp người khép lại trọn vẹn, linh hồn trở về quê hương vĩnh cửu.",
    "category": "faith",
    "isFatalPossible": true,
    "choices": [
      {
        "id": "cen_26_a",
        "textVi": "Thanh thản về cõi vĩnh hằng trong niềm tri ân sâu sắc",
        "outcomeTextVi": "Kiếp người viên mãn khép lại, tấm gương nhân nghĩa sáng mãi ngàn sau.",
        "healthDelta": 0,
        "happinessDelta": 50,
        "wealthDelta": 0,
        "intellectDelta": 25,
        "relationsDelta": 50,
        "isFatal": true,
        "causeOfDeathVi": "Đại thọ viên mãn 98 tuổi, thanh thản về cõi vĩnh cửu"
      }
    ]
  }
];
